var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[(_vm.status === 2)?_c('div',{staticClass:"loading"},[_vm._v("경기가 종료 되었습니다.")]):(_vm.status == 0)?_c('div',{staticClass:"loading"},[_vm._v("경기 시작 전입니다. 잠시 후 다시 시도해 주세요")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }